import { Controller } from "@hotwired/stimulus"

// Controls switching between selecting an existing member or manually entering contestant info
export default class extends Controller {
  static targets = [
    "modeField",
    "memberTab",
    "manualTab",
    "memberSection",
    "manualSection"
  ]

  static values = {
    mode: { type: String, default: "member" }
  }

  connect() {
    const initialMode = this.modeFieldTarget?.value || this.modeValue
    this.modeValue = this.normalizeMode(initialMode)
    this.updateUI()
  }

  switch(event) {
    event.preventDefault()
    this.modeValue = this.normalizeMode(event.params.mode)
    this.updateUI()
  }

  updateUI() {
    const isMember = this.modeValue === "member"
    this.setActive(this.memberTabTarget, isMember)
    this.setActive(this.manualTabTarget, !isMember)

    this.toggleSection(this.memberSectionTarget, isMember)
    this.toggleSection(this.manualSectionTarget, !isMember)

    if (this.hasModeFieldTarget) {
      this.modeFieldTarget.value = this.modeValue
    }
  }

  setActive(tab, active) {
    tab.classList.toggle("active", active)
    tab.setAttribute("aria-selected", active ? "true" : "false")
  }

  toggleSection(section, active) {
    section.classList.toggle("d-none", !active)
    this.toggleInputs(section, active)
  }

  toggleInputs(section, enable) {
    const inputs = section.querySelectorAll("input, select, textarea")
    inputs.forEach(input => {
      if (enable) {
        input.removeAttribute("disabled")
      } else {
        input.setAttribute("disabled", "disabled")
      }
    })
  }

  normalizeMode(mode) {
    return mode === "manual" ? "manual" : "member"
  }
}
